import Hidden from '@mui/material/Hidden'
import { getAuth } from 'firebase/auth'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import DesktopDrawer from './desktop'
import MobileDrawer from './mobile'
import { BucketsByUserIdDocument } from '../../../../graphql/generated'
import logger from '../../../../utils/logger'

export default function Drawer() {
  const queryParams = useParams<{ bucketId: string }>()
  const userId = getAuth().currentUser?.uid
  const results = useQuery(BucketsByUserIdDocument, {
    skip: !userId,
    variables: { userId: userId! },
    onError: (e) => {
      logger.error(e)
    }
  })
  const bucketId = queryParams.bucketId ?? results.data?.userProfile?.currentBucketId

  if (!userId) {
    return null
  }

  return (
    <>
      <Hidden lgUp>
        <MobileDrawer bucketId={bucketId || ''} userId={userId} />
      </Hidden>
      <Hidden lgDown>
        <DesktopDrawer bucketId={bucketId || ''} userId={userId} />
      </Hidden>
    </>
  )
}
